import type { AccountSource } from 'owa-account-source-list-store';
import { AccountSourceType, getAccountSourceListStore } from 'owa-account-source-list-store';
import * as Schema from 'owa-graph-schema';
import { trace } from 'owa-trace';

// Converts from an AccountSource (from the account source list store) into the GraphQL AccountSource
function toGraphQLAccountSource(info: AccountSource): Schema.AccountSource {
    const capabilities = {
        hasServerMailbox: info.characteristics.isMicrosoft365Hosted,
        hasLocalFile: false,
        isLocalMailboxCache: false,
        supportsCalendar: info.characteristics.supportsCalendar,
        supportsContacts: info.characteristics.supportsContacts,
        supportsMail: info.characteristics.supportsMail,
        supportsSettings: info.characteristics.supportsSettings,
    } as Schema.AccountCapabilities;

    // Monarch currently only supports M365 mailboxes and this code will be removed once
    // the code base is using the owa-account-source-list-store directly, so for now we
    // rely on all accounts having an m365mailbox.
    const mailbox = {
        id: info.sourceId,
        mailboxType:
            info.sourceType === AccountSourceType.Office365 ? 'OFFICE365' : 'OUTLOOKDOTCOM',
        emailAddress: info.m365mailbox!.emailAddress,
        displayName: info.m365mailbox!.displayName,
    } as Schema.AccountMailbox;

    return {
        id: info.sourceId,
        capabilities: capabilities,
        displayName: info.displayName,
        mailbox: mailbox,
    };
}

/**
 * Query Web resolver responsible for getting the account source list
 */
export default function getGraphQLAccountSourceFromSourceListStore(): Schema.AccountSource[] {
    trace.verbose('In AccountSourceListWeb query');

    // Get the account source list store and convert to the GraphQL schema
    return getAccountSourceListStore().sources.map(source => toGraphQLAccountSource(source));
}
